import type { PrivateTeamsMeetingInvitee, TeamsMeeting, User } from '../../state/types';

type GetPrivateTeamsMeetingInviteeId = (
  meetingId: TeamsMeeting['id'],
  officeUserId: User['officeUserId']
) => PrivateTeamsMeetingInvitee['id'];
export const getPrivateTeamsMeetingInviteeId: GetPrivateTeamsMeetingInviteeId = (meetingId, officeUserId) =>
  btoa(`${meetingId}-${officeUserId}`);

type GetPrivateTeamsMeetingInviteeIds = (
  meetingId: TeamsMeeting['id'],
  officeUserIds: User['officeUserId'][]
) => PrivateTeamsMeetingInvitee['id'][];
export const getPrivateTeamsMeetingInviteeIds: GetPrivateTeamsMeetingInviteeIds = (meetingId, officeUserIds) =>
  officeUserIds.map((officeUserIds) => getPrivateTeamsMeetingInviteeId(meetingId, officeUserIds));
